<template>
  <div :id="componentId" class="sp2-module-3" :style="moduleStyle">
    <div class="sp2-module-3-wrap">
      <div class="sp2-avatar-section">
        <div class="sp2-avatar-wrap">
          <img
            v-if="avatarUrl"
            class="sp2-avatar-image"
            referrerpolicy="no-referrer"
            :src="avatarUrl"
          />
          <div v-else class="sp2-avatar-placeholder">头像</div>
        </div>
        <div class="sp2-avatar-name">{{ name || '姓名' }}</div>
        <div class="sp2-avatar-divider" />
        <div class="sp2-avatar-position">{{ position || '职位' }}</div>
      </div>

      <div class="sp2-chart-section">
        <img
          v-if="imageUrl"
          class="sp2-chart-image"
          referrerpolicy="no-referrer"
          :src="imageUrl"
        />
        <div v-else class="sp2-chart-placeholder">请配置图片</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SpTwoModule3',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_3'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      avatarUrl: '',
      name: '寇 枫',
      position: '中国品牌杂志社 总编辑',
      imageUrl: ''
    };
  },
  computed: {
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
};
</script>

<style scoped>
.sp2-module-3 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-3-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 36px;
  width: 2000px;
  min-height: 420px;
  padding: 60px 0;
  box-sizing: border-box;
}

.sp2-avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 254px;
  height: 354px;
  flex-shrink: 0;
}

.sp2-avatar-wrap {
  width: 254px;
  height: 254px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #e0e0e0;
}

.sp2-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp2-avatar-name {
  width: 238px;
  height: 30px;
  margin-top: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}

.sp2-avatar-divider {
  width: 35px;
  height: 4px;
  margin-top: 6px;
  background: linear-gradient(90deg, #1F48BC 0%, #6592E3 100%);
  border-radius: 2px;
}

.sp2-avatar-position {
  width: 262px;
  height: 30px;
  margin-top: 6px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}

.sp2-chart-section {
  width: 1110px;
  height: 354px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  background: #e0e0e0;
}

.sp2-chart-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-chart-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>
